import { useNavigate, useParams } from "react-router-dom"
import ErrorBoundary from "../../Components/ErrorBoundary/ErrorBoundary"
import { useEffect, useState } from "react"
import { useOffers } from "../../Providers/OffersProvider"
import LoadingSpinner from "../../Components/Components/LoadingSpinner"
import { reverseDate } from "../../Helpers/ValidatorHelper"
import { ConvertPriceToString } from "../../Helpers/CustomConverter"
import useDownloadCustomerOffer from "../../Hooks/useDownloadCustomerOffer"
import { FaFilePdf } from "react-icons/fa6";
import axios from "axios"
import OferDetailsProducts from "./Components/OferDetailsProducts"
import { toast } from "react-toastify"
import YesNoMessageModal from "../../Components/Components/Modals/YesNoMessageModal"
import ScrollUpArrow from "../../Components/Components/ScrollUpArrow"
import { useAuth } from "../../Providers/AuthProvider"
import { useCart } from "../../Providers/CartProvider"
import InformationErrorModal from "../../Components/Components/Modals/InformationErrorModal"
import YesNoCancelMessageModal from "../../Components/Components/Modals/YesNoCancelMessageModal"

const OfferDetails = () => {
    const navigate = useNavigate()
    const { offerNo, offerSiteId } = useParams()
    const { getCustomerOffer, handleGetNumberOfUnreadCustomerOffer, handleChangeOfferStatus, handleCreateUpdateSavedOffer, handleDeleteSavedOffer } = useOffers()
    const { downloadCustomerOffer } = useDownloadCustomerOffer()
    const { authState } = useAuth()
    const { cartItems, addProductsToBasket } = useCart()

    const [isLoading, setIsLoading] = useState(false)
    const [offerHeader, setOfferHeader] = useState(null)
    const [offerItems, setOfferItems] = useState([])
    const [isPdfDownloading, setIsPdfDownloading] = useState(false)

    const [itemsToCreateOfferRequest, setItemsToCreateOfferRequest] = useState(null)
    const [showCreateOfferRequestModal, setShowCreateOfferRequestModal] = useState(false)
    const [isLoadingOfferRequest, setIsLoadingOfferRequest] = useState(false)

    const [itemsToCreateRetailerOffer, setItemsToCreateRetailerOffer] = useState(null)
    const [showCreateRetailerOfferModal, setShowCreateRetailerOfferModal] = useState(false)

    const [realizeOfferModalObj, setRealizeOfferModalObj] = useState({ show: false, message: '', offerItems: [] })
    const [isLoadingBasket, setIsLoadingBasket] = useState(false)
    const [showQuestionAboutReplaceBasket, setShowQuestionAboutReplaceBasket] = useState(false)

    useEffect(() => {
        const source = axios.CancelToken.source()

        handleGetOffer(source.token)

        return () => {
            source.cancel()
        }
    }, [])

    const handleGetOffer = async (cancleToken) => {
        setIsLoading(true)
        var offer = await getCustomerOffer(offerNo, offerSiteId)
        setOfferHeader(offer.header)
        setOfferItems(offer.items)
        setIsLoading(false)
        //Ustawiamy status na przeczytana
        handleChangeOfferStatus(offerNo, offerSiteId, cancleToken)
        handleGetNumberOfUnreadCustomerOffer()
    }

    const handleDownloadPdf = async () => {
        setIsPdfDownloading(true)
        await downloadCustomerOffer(offerNo, offerSiteId)
        setIsPdfDownloading(false)
    }

    const validateString = (text) => {
        if (text && text.trim() != "") {
            return text
        }
        else {
            return '----'
        }
    }

    const handleCreateOfferRequest = () => {
        if (offerItems && offerItems.length > 0) {
            setItemsToCreateOfferRequest(offerItems)
            setShowCreateOfferRequestModal(true)
        }
        else {
            toast.warning('Oferta nie zawiera produktów!')
        }
    }

    const handleCreateOfferRequestModalAnswer = async (answer) => {
        if (answer) {
            await handleCreateOfferMainFunc(false)
        }
        setShowCreateOfferRequestModal(false)
        setItemsToCreateOfferRequest(null)
    }

    const handleCreateRetailerOffer = () => {
        if (offerItems && offerItems.length > 0) {
            setItemsToCreateRetailerOffer(offerItems)
            setShowCreateRetailerOfferModal(true)
        }
        else {
            toast.warning('Oferta nie zawiera produktów!')
        }
    }

    const handleCreateRetailerOfferModalAnswer = async (answer) => {
        if (answer) {
            await handleCreateOfferMainFunc(true)
        }
        setShowCreateRetailerOfferModal(false)
        setItemsToCreateRetailerOffer(null)
    }

    const handleCreateOfferMainFunc = async (isRetailerOffer) => {
        setIsLoadingOfferRequest(true)
        let offerMode = isRetailerOffer ? 1 : 0

        await handleDeleteSavedOffer(offerMode)
        let dateNow = new Date()
        const offerRequest = {
            investor: null, investName: '', additionalInfo: '', expectedDate: dateNow.setDate(dateNow.getDate() + 14), retailerTax: 23,
            totalPriceMarkup: 0, serviceNetValue: 0
        }
        let tmpOfferItems = isRetailerOffer ? itemsToCreateRetailerOffer : itemsToCreateOfferRequest
        tmpOfferItems.forEach(i => {
            i.priceMarkup = 0
            i.costNet = i.priceNet
            i.product = {}
            i.product.title = i.externalArticle ? i.artName : ''
        })
        await handleCreateUpdateSavedOffer(offerMode, offerRequest, tmpOfferItems, offerHeader.expirationDate)
        setIsLoadingOfferRequest(false)
        navigate(`/OfferRequest/${offerMode}/true/null`)
    }

    const handleLoadCustomerOffer = async () => {
        if (!authState.user) {
            toast.warning('Prosze się zalogować')
            return
        }
        if (!authState.custId) {
            toast.warning('Brak wybranego kontrahenta')
            return
        }
        const now = new Date()
        const expiredOfferDate = new Date(offerHeader.expirationDate)
        const nowToCompare = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const expiredToCompare = new Date(expiredOfferDate.getFullYear(), expiredOfferDate.getMonth(), expiredOfferDate.getDate())

        let tmpItems = offerItems.map(item => ({
            ...item,
            qty: item.qty - item.orderQty
        })).filter(item => item.qty > 0) // Odejmujemy ilości zamówione i w razie gdy jest 0 to je usuwamy    

        if (expiredToCompare < nowToCompare) {
            setRealizeOfferModalObj({
                show: true,
                message: 'Oferta jest przeterminowana, nie można jej zrealizować!\n Zostanie utworzony nowy koszyk z pozycjami z oferty.\n Ceny zostaną przeliczone zgodnie z cennikiem!',
                offerItems: offerItems
            })
            return
        }
        else if (tmpItems.length === 0) {
            setRealizeOfferModalObj({
                show: true,
                message: 'Oferta została już całkowicie zamówiona / zrealizowana!\n Zostanie utworzony nowy koszyk z pozycjami z oferty.\n Ceny zostaną przeliczone zgodnie z cennikiem!',
                offerItems: offerItems
            })
            return
        }
        else {
            navigate(`/Cart?custId=${authState.custId}&offerNo=${offerNo}&offerSiteId=${offerSiteId}`)
        }
    }

    const handleRealizeOfferModalClose = async () => {
        if (cartItems && cartItems.basketItems && cartItems.basketItems.length > 0) {
            setShowQuestionAboutReplaceBasket(true)
        }
        else {
            setIsLoadingBasket(true)
            await addProductsToBasket(realizeOfferModalObj.offerItems, true)
            setIsLoadingBasket(false)
            navigate('/Cart')
        }
        setRealizeOfferModalObj(prev => ({
            show: false,
            message: '',
            offerItems: prev.offerItems,
        }))
    }

    const handleMessageModalResult = (answer) => {
        setShowQuestionAboutReplaceBasket(false)
        if (answer === 'Cancel') {
            return
        }
        var replaceBasket = answer === 'Yes' ? true : false
        handleAddItemsToCart(replaceBasket)
    }

    const handleAddItemsToCart = async (replaceBasket) => {
        setIsLoadingBasket(true)
        if (realizeOfferModalObj.offerItems && realizeOfferModalObj.offerItems.length > 0) {
            await addProductsToBasket(realizeOfferModalObj.offerItems, replaceBasket)
            setRealizeOfferModalObj({ show: false, message: '', offerItems: [] })
        }
        else {
            await addProductsToBasket(offerItems.filter(i => i.externalArticle === false), replaceBasket)
        }
        setIsLoadingBasket(false)
        navigate('/Cart')
    }

    if (isLoading) {
        return <LoadingSpinner loadingText="Pobieranie oferty ..." />
    }
    if (!offerHeader) {
        return null
    }
    if (isLoadingOfferRequest || isLoadingBasket) {
        return <LoadingSpinner loadingText="Wczytywanie pozycji ..." />
    }
    return (<ErrorBoundary>
        <ScrollUpArrow />
        <YesNoMessageModal
            show={showCreateOfferRequestModal}
            onHide={handleCreateOfferRequestModalAnswer}
            title={'Tworzenie zapytania ofertowego'}
            message={'Uwaga! Jeżeli masz nie zakończone zapytanie ofertowe zostanie ono nadpisane! Czy chcesz stworzyć nowe zapytanie ofertowe?'}
            showCloseButton={false}
        />
        <YesNoMessageModal
            show={showCreateRetailerOfferModal}
            onHide={handleCreateRetailerOfferModalAnswer}
            title={'Tworzenie oferty'}
            message={'Uwaga! Jeżeli masz nie zakończoną oferte zostanie ona nadpisana! Czy chcesz stworzyć nową oferte?'}
            showCloseButton={false}
        />
        <InformationErrorModal
            show={realizeOfferModalObj.show}
            setShow={handleRealizeOfferModalClose}
            title={"UWAGA"}
            message={realizeOfferModalObj.message}
            isError={true}
            isVersionControlInformation={false}
            showCloseButton={false}
        />
        <YesNoCancelMessageModal
            show={showQuestionAboutReplaceBasket}
            onHide={handleMessageModalResult}
            title={'Pytanie'}
            message={'Twój koszyka zawiera już pozycje, co chcesz zrobić z zaznaczonymi pozycjami, które dodajesz do koszyka?'}
            yesText='Nadpisz koszyk'
            noText='Dopisz do koszyka'
        />

        <div className="container-fluid-with-paddings">
            <div className="row mt-4 mb-4">
                <div className="col-12 col-sm-10 text-start">
                    <b style={{ fontSize: '25px' }}>{`Oferta numer: ${offerNo} z ${reverseDate(offerHeader.offerDate.substring(0, offerHeader.offerDate.indexOf('T')))}`}</b>
                </div>
                <div className="col-12 col-sm-2 d-flex justify-content-start justify-content-sm-end">
                    {isPdfDownloading ?
                        (<LoadingSpinner bubble={false} width={1.5} height={1.5} />) :
                        (<FaFilePdf size={30} style={{ color: 'var(--primary)', cursor: 'pointer' }} onClick={handleDownloadPdf} />)
                    }
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12 d-flex flex-column flex-md-row">
                    <button onClick={handleLoadCustomerOffer} className="btn-app-primary">Zrealizuj ofertę</button>
                    <button onClick={handleCreateOfferRequest} className="btn-app-secondary ms-0 ms-md-3 mt-3 mt-md-0">Utwórz nowe zapytanie ofertowe z pozycji oferty</button>
                    <button onClick={handleCreateRetailerOffer} className="btn-app-secondary ms-0 ms-md-3 mt-3 mt-md-0">Przygotuj ofertę dla klienta</button>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-6 d-flex flex-column">
                    <div className="main-container-holder d-flex flex-column h-100">
                        <b className="panel-header-title">Daty:</b>
                        <span>{`Data zapytania:   ${validateString(reverseDate(offerHeader.requestDate.substring(0, offerHeader.requestDate.indexOf('T'))))}`}</span>
                        <span>{`Data przygotowania:   ${validateString(reverseDate(offerHeader.offerDate.substring(0, offerHeader.offerDate.indexOf('T'))))}`}</span>
                        <span>{`Data ważności:   ${validateString(reverseDate(offerHeader.expirationDate.substring(0, offerHeader.expirationDate.indexOf('T'))))}`}</span>
                    </div>
                </div>
                <div className="col-12 col-md-6 d-flex flex-column mt-2 mt-md-0">
                    <div className="main-container-holder d-flex flex-column h-100">
                        <b className="panel-header-title">Informacje:</b>
                        <span>{`Status:  ${offerHeader.status}`}</span>
                        <span>{`Sprzedający:   ${validateString(offerHeader.source)}`}</span>
                        <span>{`Inwestycja:   ${validateString(offerHeader.investmentName)}`}</span>
                        <b>{`Wartośc netto PLN:   ${ConvertPriceToString(offerHeader.netValue, null)}`}</b>
                        <b>{`Wartośc brutto PLN:   ${ConvertPriceToString(offerHeader.grossValue, null)}`}</b>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12">
                    <div className="main-container-holder">
                        <OferDetailsProducts
                            items={offerItems}
                        />
                    </div>
                </div>
            </div>
        </div>
    </ErrorBoundary >)
}

export default OfferDetails